import React, { useState } from "react";
import "./StatsSection.css";
import BlogService from "../../Service/BlogService";
import Stat from "../Pages/image/Statistique.jpg"

const StatsSection = ({ accueil }) => {
    const [editMode, setEditMode] = useState(false);
    const [modifiedData, setModifiedData] = useState({});
    const token = sessionStorage.getItem('token');

    // Map data structure to both value and label fields
    const initialData = [
        {
            key: "annee",
            value: accueil.annee,
            label: accueil.anneeQuestion || "Années d'expertise",
            labelKey: "anneeQuestion",
            color: "blue",
        },
        {
            key: "formations",
            value: accueil.formations,
            label: accueil.formationsQuestion || "Nombre de formations",
            labelKey: "formationsQuestion",
            color: "red",
        },
        {
            key: "formateurs",
            value: accueil.formateurs,
            label: accueil.formateursQuestion || "Nombre de formateurs",
            labelKey: "formateursQuestion",
            color: "blue",
        },
        {
            key: "formes",
            value: accueil.formes,
            label: accueil.formesQuestion || "Nombre de personnes formées",
            labelKey: "formesQuestion",
            color: "red",
        },
        {
            key: "representations",
            value: accueil.representations,
            label: accueil.representationsQuestion || "Représentations locales",
            labelKey: "representationsQuestion",
            color: "blue",
        },
        {
            key: "satisfaits",
            value: accueil.satisfaits,
            label: accueil.satisfaitsQuestion || "Nombre de personnes satisfaites",
            labelKey: "satisfaitsQuestion",
            color: "red",
        }
    ];

    const [data, setData] = useState(initialData);

    const handleEditClick = () => {
        setEditMode(true);
        setModifiedData(data.reduce((acc, item) => {
            acc[item.key] = { value: item.value, label: item.label };
            return acc;
        }, {}));
    };

    const handleInputChange = (key, field, value) => {
        setModifiedData((prevData) => ({
            ...prevData,
            [key]: {
                ...prevData[key],
                [field]: value,
            },
        }));
    };

    const handleSaveClick = async () => {
        // Construct updatedAccueil with both value and label fields
        const updatedAccueil = {
            ...accueil,
            ...Object.fromEntries(
                Object.entries(modifiedData).flatMap(([key, item]) => [
                    [key, item.value], // Update value field (e.g., `annee`)
                    [data.find((d) => d.key === key).labelKey, item.label], // Update label field (e.g., `anneeQuestion`)
                ])
            ),
        };

        try {
            let response = await BlogService.putAccueil(updatedAccueil);
            console.log(response);

            // Update local data
            const updatedData = data.map((item) => ({
                ...item,
                value: modifiedData[item.key]?.value || item.value,
                label: modifiedData[item.key]?.label || item.label,
            }));
            setData(updatedData);
            setEditMode(false);
        } catch (error) {
            console.error("Error saving data:", error);
        }
    };

    return (
        <div className="chiffres-cles-section text-center py-5">
            <h2 className="text-white mb-4">SCFPS en quelques chiffres clés</h2>
            <div className="container">
                <div className="row g-4">
                    {data.map((item, index) => (
                        <div className="col-md-4" key={index}>
                            <div
                                className="card chiffres-cles-card"
                                style={{
                                    backgroundImage: `linear-gradient(rgba(23, 32, 58, 0.7), rgba(23, 32, 58, 0.7)), url("${Stat}")`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundColor: "#17203a",
                                }}
                            >
                                <div className="card-body">
                                    {editMode ? (
                                        <>
                                            <input
                                                type="text"
                                                value={modifiedData[item.key]?.value || ""}
                                                onChange={(e) =>
                                                    handleInputChange(item.key, "value", e.target.value)
                                                }
                                                className={`form-control text-${item.color} mb-2`}
                                                placeholder="Value"
                                            />
                                            <input
                                                type="text"
                                                value={modifiedData[item.key]?.label || ""}
                                                onChange={(e) =>
                                                    handleInputChange(item.key, "label", e.target.value)
                                                }
                                                className={`form-control text-${item.color}`}
                                                placeholder="Label"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <h1 className={`chiffres-cles-value text-${item.color}`}>
                                                {item.value}
                                            </h1>
                                            <p className="chiffres-cles-label">{item.label}</p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {editMode ? (
                <div className="m-5">
                    <button className="btn btn-success mt-1" onClick={handleSaveClick}>
                        Enregistrer
                    </button>
                </div>
            ) : (
                token === '' && (
                    <div className="m-5">
                        <button className="btn btn-danger mt-1" onClick={handleEditClick}>
                            Modifier
                        </button>
                    </div>
                )
            )}
            <a href="/quisommesnous" className="btn btn-danger mt-4 chiffres-cles-button">
                En savoir + sur SCFPS
            </a>
        </div>
    );
};

export default StatsSection;